export default __webpack_public_path__ + "static/media/Road Use Pricing case study.e3fff97b.pdf";